<template lang="pug">
.singleIntro
  .singleIntro-bg
    img.singleIntro-img(:src='largeImg', alt)
  .singleIntro-overlay
  .singleIntro-cont
    .button._transparent(style='visibility: hidden')
    h1.singleIntro-title {{ listing && listing.title }}
    
    .buttoncontainer
      .button.mobile-toggle(@click='$emit("enableSlider")') All Photos
      .slider-toggle(
        @click='$emit("enableSlider")',
        :style='{ visibility: listing && listing.Content.SliderImages[0] ? "visible" : "hidden" }'
      ) <span>see all photos</span>
        SvgComponent.singleIntro-expand(name='expand')
      slot
    .singleIntro-sold(v-if='listing && listing.sold') Sold Listing
</template>

<script>
  import SvgComponent from '@/components/SvgComponent.vue';
  export default {
    data() {
      return {
        // imgLoaded: false
      };
    },
    props: ['listing'],
    components: {
      SvgComponent,
    },
    computed: {
      largeImg() {
        return (
          this.$hostname +
          (this.listing?.Content.FullPageImage1?.formats.large?.url ||
            this.listing?.Content.FullPageImage1?.url)
        );
      },
    },
  };
</script>

<style lang="scss">
  .buttoncontainer {
    display: contents;
    cursor: pointer;
    @include tablet {
      display: block;
      width: 100%;
      @include gap(10px, col);
    }

    .slider-toggle {
      color: white;
      font-size: 17px;
      font-weight: 700;
      display: flex;
      align-items: center;
      gap: 12px;

      @include tablet {
        justify-content: flex-end;
      }

      @include phone {
        display: none;
      }
    }
    .mobile-toggle {
      display: none;
      background: #1F1E1E;
      color: white;
      @include phone {
        display: flex;
        align-items: center;
        justify-content: center;
        
      }
    }
   
  }
  .singleIntro {
    display: contents;
    &-sold {
      font-size: 72px;
      line-height: 86px;
      position: absolute;
      white-space: nowrap;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-weight: 800;
      font-family: 'Abhaya Libre';
      @include tablet {
        font-size: 24px;
        line-height: 29px;
        // margin-top: -2em;
        margin-bottom: 10px;
      }
    }
    &-bg {
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
      min-height: 100vh;
      min-height: -webkit-fill-available;
      overflow: hidden;
    }
    &-img {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
      object-fit: cover;
      object-position: center;
      display: block;
      z-index: -1;
    }
    &-overlay {
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.2) 30%, rgba(0, 0, 0, 0.2) 100%);
      z-index: 1;
    }
    &-cont {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 80px;
      @include tablet {
         justify-content: flex-end;
        
        margin-bottom: 56px;
        .button {
          width: 100%;
          // margin-bottom: 90px;
        }
      }

      @include phone {
        flex-direction: column;
        justify-content: space-between;
      }
    }
    &-title {
      font-size: 40px;
      font-family: 'Abhaya Libre';
      font-weight: bold;
      line-height: 30px;
      color: white;
      @include tablet {
        font-weight: bold;
        font-size: 32px;
        width: 100%;
        text-align: center;
      }
    }
  }
</style>
